<template>
  <div>
    <div class="text-center hero">
      <img class="mb-3 app-logo" src="../../assets/images/logo.png" alt="Vue.js logo">
      <h1 class="mb-4">Product Tools</h1>
      <p>&nbsp;</p>
      <button class="btn dark btn-large" @click.prevent="$parent.login()">Login</button>
      
      <button class="btn btn-primary btn-block" @click="login">Log in</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "login"
};
</script>
